import cep from "cep-promise";
import { IGeolocationProps, ILocation, ILocationProviderData } from "./types/intext";
import { createContext, useContext, useEffect, useState } from "react";

export const GeolocationContext = createContext<ILocationProviderData>(
  {} as ILocationProviderData
);

export const GeolocationProvider = ({ children }: IGeolocationProps) => {

  const [mapBig, setMapBig] = useState(false);
  const [location, setLocation] = useState<ILocation>({
    lat: null,
    lng: null,
    city: null,
    state: null,
    error: null,
    loading: true, // 👈 novo estado
  });

  useEffect(() => {
    let isMounted = true; // 👈 evita setState em componente desmontado

    if (!navigator.geolocation) {
      if (isMounted) {
        setLocation(prev => ({ ...prev, error: "Geolocalização não suportada.", loading: false }));
      }
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
          );
          const data = await res.json();

          const city =
            data.address.city ||
            data.address.town ||
            data.address.village ||
            data.address.municipality ||
            data.address.county; // 👈 fallback extra

          const state = data.address.state;

          if (isMounted) {
            setLocation({
              lat,
              lng,
              city,
              state,
              error: null,
              loading: false,
            });
          }
        } catch (err) {
          if (isMounted) {
            setLocation(prev => ({ ...prev, error: "Erro ao buscar endereço.", loading: false }));
          }
        }
      },
      (err) => {
        if (isMounted) {
          setLocation(prev => ({ ...prev, error: err.message, loading: false }));
        }
      }
    );

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <GeolocationContext.Provider value={{ location, setLocation, mapBig, setMapBig }}>
      {children}
    </GeolocationContext.Provider>
  );
};

export const useLocationData = () => useContext(GeolocationContext);
